"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CarrierAccountAction;
(function (CarrierAccountAction) {
    CarrierAccountAction["CREATED"] = "carrier_account_created";
    CarrierAccountAction["UPDATED"] = "carrier_account_updated";
    CarrierAccountAction["DELETED"] = "carrier_account_deleted";
})(CarrierAccountAction = exports.CarrierAccountAction || (exports.CarrierAccountAction = {}));
//# sourceMappingURL=carrier-account-models.v0.js.map